export default {
    methods: {
        getIndicators() {
            return this.get(`/indicator/index`)
        },
        getIndicator(indicatorId) {
            return this.get(`/indicator/${indicatorId}`)
        },
        saveIndicator(indicatorId, indicatorData) {
            if (!indicatorId) {
                return Promise.reject(new Error('Indicator ID was empty'));
            }

            return this.put(`/indicator/${indicatorId}`, indicatorData)
        },
        publishIndicator(indicatorId) {
            if (!indicatorId) {
                return Promise.reject(new Error('Indicator ID was empty'));
            }

            return this.put(`/indicator/${indicatorId}/publish`)
        },
        revertIndicatorDraftChanges(indicatorId) {
            if (!indicatorId) {
                return Promise.reject(new Error('Indicator ID was empty'));
            }

            return this.put(`/indicator/${indicatorId}/revert-draft`)
        },
    }
}